//Models
PJQ.models.bidForms.Settings = PJQ.models.BaseModel.extend({
	idAttribute: 'settingId',
	endpoint: function () {
		if (this.get('projectId') > 0) {
			return PJQ.helpers.urlHelpers.generateEndpoint([
				{
					endpoint: 'projects',
					value: this.get('projectId')
				},
				{
					endpoint: 'bidForms'
				},
				{
					endpoint: 'settings'
				}
			]);
		}
		return PJQ.helpers.urlHelpers.generateEndpoint([
			{
				endpoint: 'bidForms'
			},
			{
				endpoint: 'settings'
			}
		]);
	},
	parse: function (model) {
		if (model) {
			if (model.additionalBidDocuments) {
				this.additionalBidDocuments = new PJQ.collections.files.Files(model.additionalBidDocuments);
			}
			else {
				this.additionalBidDocuments = new PJQ.collections.files.Files();
			}
		}
		else {
			this.additionalBidDocuments = new PJQ.collections.files.Files();
		}
		return model;
	},
	beforeSave: function () {
		this.set('additionalBidDocuments', this.additionalBidDocuments.getChangedModels());
	},
	isSealedBidContact: function(id) {
		return _.size(_.filter(this.get('sealedBidContactList'), function(contact) {
			return contact.id == id;
		})) > 0;
	}
});